import antFactory from "@/js/AntDv";
import routeFactory from "@/routes";
import vuexFactory from "@/store";
import { createApp } from 'vue'
import App from './App.vue'
import 'video.js/dist/video-js.css'
import moment from 'moment'
import 'moment/dist/locale/zh-cn';

moment.locale('zh-cn');

const app: any = createApp(App);

antFactory.init(app);
vuexFactory.init(app);
routeFactory.init(app);


app.mount('#app')

